var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.MODAL_ID,
        title: _vm.title,
        size: "lg",
        centered: "",
        "ok-title": "Save",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.onSave.apply(null, arguments)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel, ok }) {
            return [
              _c("div", { staticClass: "w-100 d-flex justify-content-end" }, [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c("b-button", { on: { click: cancel } }, [
                      _vm._v("\n          Cancel\n        "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mx-1" }),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          disabled:
                            !_vm.customSize.width ||
                            !_vm.customSize.height ||
                            _vm.isSaving,
                        },
                        on: { click: ok },
                      },
                      [_vm._v("\n          Save\n        ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("label", [_vm._v("Add Custom Size:")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c(
                  "b-input-group",
                  { staticClass: "mr-1" },
                  [
                    _c("b-form-input", {
                      ref: "customSizeWidth",
                      attrs: { type: "number" },
                      on: {
                        input: (value) =>
                          _vm.onCustomSizeChange(
                            value,
                            _vm.CUSTOM_SIZE_INPUT_TYPES.WIDTH_INPUT
                          ),
                      },
                      model: {
                        value: _vm.customSize.width,
                        callback: function ($$v) {
                          _vm.$set(_vm.customSize, "width", _vm._n($$v))
                        },
                        expression: "customSize.width",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-input-group-append",
                      [
                        _c(
                          "b-input-group-text",
                          { staticStyle: { "border-right": "none" } },
                          [_c("b-icon", { attrs: { icon: "x" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-form-input", {
                      attrs: { type: "number" },
                      on: {
                        input: (value) =>
                          _vm.onCustomSizeChange(
                            value,
                            _vm.CUSTOM_SIZE_INPUT_TYPES.HEIGHT_INPUT
                          ),
                      },
                      model: {
                        value: _vm.customSize.height,
                        callback: function ($$v) {
                          _vm.$set(_vm.customSize, "height", _vm._n($$v))
                        },
                        expression: "customSize.height",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-checkbox",
                  {
                    staticClass: "w-100",
                    on: { change: _vm.onMaintainAspectRatioChange },
                    model: {
                      value: _vm.maintainAspectRatio,
                      callback: function ($$v) {
                        _vm.maintainAspectRatio = $$v
                      },
                      expression: "maintainAspectRatio",
                    },
                  },
                  [_vm._v("\n          Maintain aspect ratio\n        ")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "my-3" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }